import axios from "../axios";

const create = (data) => {
  return axios.post(`/share-capital-authorization`, data);
};

const update = (shareAuthorizationId, data) => {
  return axios.put(
    `/share-capital-authorization/${shareAuthorizationId}`,
    data
  );
};

const remove = (id) => {
  return axios.delete(`/share-capital-authorization/${id}`);
};

const getList = (companyId) => {
  return axios
    .get(`/share-capital-authorization?companyId=${companyId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const submitAuthorizations = (data) => {
  return axios.post(
    `/share-capital-authorization/submit-share-capital-authorization`,
    data
  );
};

const shareAuthorizationDataService = {
  create,
  update,
  remove,
  getList,
  submitAuthorizations,
};

export default shareAuthorizationDataService;
